export default __webpack_public_path__ + "static/media/evo-icon-active.ef18bf0d.svg";